import type { ZodType } from "zod";
import type { LDFlagSet } from "launchdarkly-js-client-sdk";
import { createContext } from "react";

export interface FeatureFlagIdentity {
	userId?: string;
	tenantId?: string;
	companyId?: string;
	salesforceId?: string;
	email?: string;
	userName?: string;
}

export interface FeatureFlagsContextProps {
	getAllFeatureFlags: () => LDFlagSet;
	isFeatureFlagEnabled: {
		(featureFlag: string): boolean;
		<T>(featureFlag: string, defaultValue: T, schema: ZodType<T>): T;
	};
	setFeatureFlagIdentity: (featureFlagIdentity: FeatureFlagIdentity | undefined) => Promise<void>;
}

export const initialProps: FeatureFlagsContextProps = {
	getAllFeatureFlags: () => ({}),
	isFeatureFlagEnabled: (() => {
		function isFeatureFlagEnabled(featureFlag: string): boolean;
		function isFeatureFlagEnabled<T>(featureFlag: string, defaultValue: T, schema: ZodType<T>): T;
		function isFeatureFlagEnabled<T>(_featureFlag: string, defaultValue?: T): T | boolean {
			return defaultValue !== undefined ? defaultValue : false;
		}
		return isFeatureFlagEnabled;
	})(),
	setFeatureFlagIdentity: () => Promise.resolve(),
};

export const FeatureFlagsContext = createContext<FeatureFlagsContextProps>(initialProps);
